import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { get } from 'lodash'
import { Button, Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown } from '@fortawesome/pro-solid-svg-icons'

import api from 'common/api'
import { actions as snactions } from 'store/snackbar'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 'unset',
      color: theme.palette.grey[500],
    },
  }
})

const Priority = ({ message, onChange, isFirst, isLast }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const updatePriority = (Priority) => {
    api
      .patch(`/api/college/${message.Scid}/message/${message.Id}`, message, {
        ...message,
        Priority,
      })
      .then(() => onChange())
      .catch(() => dispatch(snactions.addSnackbarItem('There was a problem updating your message.')))
  }
  const currentPriority = get(message, 'Priority')
  return (
    <Box
      display="flex"
      alignItems="center"
    >
      <Box
        display="flex"
        flexDirection="column"
      >
        {!isFirst && (
          <Button
            aria-label={`Move this message up in priority to position ${currentPriority - 1}`}
            onClick={() => updatePriority(currentPriority - 1)}
            classes={{ root: classes.root }}
          >
            <FontAwesomeIcon
              icon={faArrowUp}
              size="sm"
            />
          </Button>
        )}
        {!isLast && (
          <Button
            aria-label={`Move this message down in priority to position ${currentPriority + 1}`}
            onClick={() => updatePriority(currentPriority + 1)}
            classes={{ root: classes.root }}
          >
            <FontAwesomeIcon
              icon={faArrowDown}
              size="sm"
            />
          </Button>
        )}
      </Box>
      <Typography variant="body2">{currentPriority}</Typography>
    </Box>
  )
}
Priority.propTypes = {
  message: PropTypes.object.isRequired,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Priority
